// extracted by mini-css-extract-plugin
module.exports = {"container":"InviteesListItem_container__2isfo","item":"InviteesListItem_item__1YEob","orderId":"InviteesListItem_orderId__1_SJA","removeBtn":"InviteesListItem_removeBtn__20ZlS"};